import { routerMiddleware } from "connected-react-router";
import { History } from "history";
import { applyMiddleware, compose, createStore, StoreEnhancer } from "redux";
import { loadUser } from "redux-oidc";
import thunk from "redux-thunk";
import { getUserManager } from "../../auth";
import { createRootReducer } from "./rootReducerHelper";

export const configureStore = <T>(reducers: {}, initialState: T, history: History) => {
  const middleware = [thunk, routerMiddleware(history)];

  // In development, use the browser's Redux dev tools extension if installed
  const enhancers: StoreEnhancer[] = [];
  const isDevelopment = process.env.NODE_ENV === "development";
  if (isDevelopment && typeof window !== "undefined" && (window as any).devToolsExtension) {
    enhancers.push((window as any).devToolsExtension() as StoreEnhancer);
  }

  const store = createStore(
    // New root reducer with router state
    createRootReducer(reducers, history),
    initialState,
    compose(
      // For dispatching history actions
      applyMiddleware(...middleware),
      ...enhancers,
    ),
  );

  loadUser(store, getUserManager());

  return store;
};
